const domain = {
  Boot: {
    ...global.$ComDomain.Boot,
    default: global.$ComDomain.Boot.print
  },
  Modules: {
    ...global.$ComDomain.Modules,
    marketOrder: global.$ComDomain.baseModules.market + '/order/',
    marketProduct: global.$ComDomain.baseModules.market + '/product/'
  },
  // 用户信息服务接口
  User: {
    // [POST] 用户密码登录
    login: '/sys/login_mobile_password',
    // [POST] 用户验证码登录
    loginByIc: '/sys/login_mobile_ic',
    // [POST] 用户快速注册
    register: '/api/register',
    // [PUT] 找回用户密码
    getPassword: '/api/getBackPassword',
    // [GET] 发送手机验证码
    code: '/api/sendIdentifyingCode',
    // [DELETE] 删除用户信息
    delete: '/sys/user/delete',
    // [GET] 获取登录的用户信息
    info: '/sys/user/info/',
    // [GET] 获取所有用户列表（支持分页）
    list: '/sys/user/list',
    // [PUT] 修改登录用户密码
    password: '/sys/user/password',
    // [GET] 获得用户头像
    photo: '/sys/user/loadPhoto/',
    // [POST] 保存用户信息
    save: '/sys/user/save',
    // [PUT] 修改用户信息
    update: '/sys/user/update',
    // [GET] 菜单
    menuList: '/sys/menu/list',
    // [GET POST DELETE] 用户需求
    demand: '/demand/',
    // [PUT] 用户需求变更为已处理状态
    demanded: '/demand/handled',
    // [GET] 验证码
    captcha: '/demand/captcha.jpg'
  },
  // 即时消息服务接口
  Message: {
    // [SOCKET] 即时消息接口
    endpoint: '/endpoint',
    // [SOCKET] 订阅即时消息
    subscribe: '/user/queue/private',
    // [GET] 根据条件查询消息
    list: '/imessage/list',
    // [DELETE] 批量删除消息
    delete: '/imessage/delete/',
    // [PUT] 更新消息状态为已读
    read: '/imessage/read/'
  },
  Role: {
    // [GET] 角色列表分页
    list: '/sys/role/list',
    // [GET] 角色信息（单条）
    info: '/sys/role/info/',
    // [DELETE] 角色删除
    delete: '/sys/role/delete/',
    // [POST] 角色保存
    save: '/sys/role/save',
    // [PUT] 角色更新
    update: '/sys/role/update',
    // [GET] 角色列表
    select: '/sys/role/select'
  },
  // 收货地址
  Address: {
    // [GET POST PUT DELETE] 收货地址
    default: '/user/address/',
    // [PUT] 修改收货地址
    byOrder: '/order/user/address'
  },
  Invoice: {
    // [GET POST PUT DELETE] 订单发票
    default: '/user/invoice/',
    // [PUT] 设置是否开发票
    switch: '/order/user/invoice',
    // [GET] 订单发票列表、查询订单发票详情
    byOrder: '/order/invoice/',
    // [GET] 查询订单发票详情
    byManager: '/order/invoice/manager'
  },
  Order: {
    // [GET POST PUT DELETE] 用户订单
    user: '/order/user/',
    // [POST] 自动报价下单
    autoAdd: '/order/user/auto/add',
    // [POST] 立即询价
    add: '/order/user/add',
    // [POST] 订单报价
    offer: '/order/manage/offer',
    // [POST] 工厂取消报价
    cancelOffer: '/order/manage/offer/cancel',
    // [POST] 用户取消订单
    cancelByUser: '/order/user/cancel',
    // 创客集市取消订单
    cancelByMarket: 'market:/order/cancel/',
    // [POST] 工厂记录生产信息
    record: '/order/production/record',
    // [POST] 工厂确认生产
    production: '/order/manage/production',
    // [GET PUT] 订单管理
    byManager: '/order/manage/',
    // [POST] 工厂取消订单
    cancel: '/order/manage/cancel',
    // [GET] 查询订单日志
    log: '/order/log',
    // 创客集市订单列表
    byMarket: 'market:/order/list',
    // 创客集市订单图片
    thumb: '/file/'
  },
  // 支付
  Payment: {
    // [GET] 查询订单支付方式列表、详情
    default: '/order/paymentMethod/',
    // [GET] 订单支付凭证
    voucher: '/order/orderPayVoucher/',
    // [POST] 线下支付
    offline: '/order/user/pay/offline',
    // [POST] 确认支付订单
    confirm: '/order/manage/pay/confirm'
  },
  // 发货、物流
  Logistics: {
    // [GET] 查询订单物流详情
    detail: '/order/logistics/',
    // [GET] 查询物流商家
    merchants: '/logistics/merchants',
    // [POST] 工厂发货
    deliver: '/order/manage/deliver',
    // [POST] 签收
    signin: '/order/user/signin/',
    // 创客集市确认收货
    finish: 'market:/order/finish/'
  },
  // 订单退货
  Refund: {
    // [GET POST DELETE] 订单退货
    default: '/order/user/refund',
    // [GET] 订单退货详情
    detail: '/order/refund/',
    // [POST] 审核订单退货数据
    audit: '/order/manage/refund/audit',
    // [POST] 确认已退款
    confirm: '/order/manage/refund/fee/confirm',
    // [POST] 工厂发起退款
    apply: '/order/manage/refund/apply',
    // 创客集市退款申请
    applyByMarket: 'market:/trade/refund/apply/',
    // [GET PUT] 审核订单退货
    byManager: '/order/manage/refund',
    // 创客集市退款订单列表
    byMarket: 'market:/order/list/refund'
  },
  // 模型库服务接口
  Model: {
    // [PUT] 匿名用户转为正式用户
    revise: '/model/anon2loginUser/',
    // [DELETE] 删除模型附件
    deleteAttach: '/model/delAttachment/',
    // [DELETE] 批量删除模型信息
    delete: '/model/delete',
    // [GET] 获得3D模型文件
    download: '/model/download/',
    // [GET] 查询模型库，返回分页列表
    list: '/model/list',
    // [GET] 获得3D模型缩略图
    thumb: '/model/loadImage/',
    // [GET] 根据模型ID取得模型信息
    query: '/model/queryObject',
    // [POST] 根据模型ID取得模型信息(列表)
    queryList: '/model/queryListById',
    // [POST] 保存模型库参数
    save: '/model/save',
    // [POST] 上传3D模型文件
    upload: '/model/upload/',
    // [POST] 更新3D模型文件
    update: '/model/update3DFile/',
    // [PUT] 变更模型库参数信息
    updateInfo: '/model/update/'
  },
  // 类别、材料库服务接口
  Material: {
    // [POST] 批量级联删除类别库
    deleteAll: '/material/deleteAll',
    // [DELETE] 批量删除材料库
    delete: '/material/deleteMaterial',
    // [DELETE] 批量删除设备信息（EQIP)、打印工艺（TECH）、表面处理工艺分类（SURC）和条目（SURI）信息
    deleteEPFInfo: '/material/deletEPFInfo/',
    // [GET] 根据条件查询设备信息（EQIP)、打印工艺（TECH）、表面处理工艺分类（SURC）和条目（SURI）信息
    listEPFInfos: '/material/listEPFInfos',
    // [GET] 取得材料库详细信息
    info: '/material/getMaterialInfo/',
    // [GET] 查询类别库信息
    listByCate: '/material/list',
    // [GET] 查询材料库信息（支持分页）
    list: '/material/listMaterialInfos',
    // [GET] 根据条件查询材料属性信息
    listBy: '/material/listMaterialParams',
    // [GET] 获得材料图片
    img: '/material/loadMaterialImage/',
    // [GET] 获得表面处理工艺图片
    surfaceImg: '/material/loadSurfaceImage/',
    // [POST] 保存材料库信息
    save: '/material/saveMaterialInfo',
    // [PUT] 更新材料库信息
    update: '/material/updateMaterialInfo',
    // [POST] 保存材料库参数
    saveParams: '/material/saveMaterialParams',
    // [POST] 保存类别库信息
    saveCategory: '/material/save',
    // [PUT] 更新类别库信息
    updateCategory: '/material/updateCategoryInfo'
  },
  // 用户设定的材料参数信息
  Params: {
    // [GET] 根据条件查询用户设定的材料参数信息(用户设定的)
    list: '/material/listUserSettingMaterialParams',
    // [PUT] 更新
    update: '/material/updateUserSettingMaterialParams',
    // [POST] 提交
    submit: '/model/submit',
    // [DELETE] 删除
    delete: '/model/delUserSettingInfo/',
    // [GET] 获得模型自动报价信息
    quote: '/model/getAutoQuotationInfo'
  },
  File: {
    // [DELETE] 删除文件接口
    delete: '/file/mo/delete/',
    // [GET] 下载文件接口
    download: '/file/mo/download/',
    // [POST] 上传文件接口
    upload: '/file/mo/upload'
  },
  // 系统服务接口
  Sys: {
    // [DELETE] 删除菜单
    delete: '/sys/menu/delete/',
    // [GET] 菜单信息
    info: '/sys/menu/info/',
    // [GET] 所有菜单列表
    list: '/sys/menu/list',
    // [GET] 导航菜单
    nav: '/sys/menu/nav',
    // [POST] 保存菜单
    save: '/sys/menu/save',
    // [GET] 选择菜单
    select: '/sys/menu/select',
    // [PUT] 修改菜单
    update: '/sys/menu/update'
  }
}

export default domain



// WEBPACK FOOTER //
// ./src/router/domain.js